import { useState, useEffect } from 'react';

function isPlatformSafari() {
  return typeof navigator !== "undefined" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function usePlatformSafari() {
  const [isMatch, setIsMatch] = useState(false);
  useEffect(() => {
    setIsMatch(isPlatformSafari());
  }, []);
  return isMatch;
}

export { isPlatformSafari, usePlatformSafari };
//# sourceMappingURL=platform.is-safari.js.map
